module.exports = __webpack_public_path__ + "assets/img/3.daedb8bb.png";